import { log, LOG_LEVELS } from '../../../common/config/app_logger';

// Session-only flag for 'default' dismissals (resets on page reload)
let dismissedThisSession = false;
let onPermissionRequest: (() => Promise<NotificationPermission>) | null = null;

export const initializePermissionTriggers = (
  requestFn: () => Promise<NotificationPermission>
): void => {
  onPermissionRequest = requestFn;
};

export const resetState = (): void => { dismissedThisSession = false; };

const shouldRequestPermission = (userId: number | null, allowWithoutUserId = false): boolean => {
  if ((!userId && !allowWithoutUserId) || dismissedThisSession) return false;
  if (typeof Notification === 'undefined' || Notification.permission !== 'default') return false;
  return true;
};

export const requestPermission = async (userId: number | null, allowWithoutUserId = false): Promise<void> => {
  if (!onPermissionRequest || !shouldRequestPermission(userId, allowWithoutUserId)) return;

  try {
    const permission = await onPermissionRequest();
    if (permission === 'default') {
      dismissedThisSession = true;
    }
  } catch (error) {
    log(LOG_LEVELS.ERROR, 'PermissionTriggers', 'Permission request failed', error);
  }
};
